'use es6';

import { SET_AUTH } from 'simple-menus-core/actions/ActionTypes';
import SeamlessImmutable from 'seamless-immutable';
export default function Auth(state = SeamlessImmutable({}), action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case SET_AUTH:
      {
        return payload;
      }
    default:
      {
        return state;
      }
  }
}